import { z } from "zod";

export const attachmentSchema = z.object({
  agreed: z.nullable(z.boolean()),
  agreementId: z.nullable(z.string().or(z.number())),
  attachmentId: z.nullable(z.string().or(z.number())),
  biometric: z.nullable(z.boolean()),
  controlHash: z.nullable(z.string()),
  dmsId: z.nullable(z.string().or(z.number())),
  dmsVersion: z.nullable(z.string().or(z.number())),
  fileName: z.nullable(z.string()),
  fileType: z.string(),
  fileTypeCode: z.string(),
  forRepair: z.boolean(),
  groupId: z.number().or(z.null()),
  humanName: z.string(),
  internal: z.boolean(),
  location: z.nullable(
    z.object({
      accuracy: z.number(),
      desc: z.nullable(z.unknown()),
      lat: z.number(),
      lng: z.number(),
      time: z.number(),
      type: z.string(),
    })
  ),
  paperRequest: z.boolean(),
  size: z.nullable(z.number()),
  uid: z.nullable(z.string()),
});
